import { focus, pxToRem, visuallyHidden } from '../../helpers'
import { StyleFn } from '..'

export const Toggle: StyleFn = (theme) => {
  const { color, font, opacity, size } = theme
  const { focusWithPseudo } = focus(theme)

  const colors = {
    label: color.getModalValues(color.text.secondary),
    focus: color.getModalValues(color.border.focus),
    on: {
      background:
        color.type === 'light'
          ? color.background.interactive.primary.small
          : color.background.interactive.primaryReverse.small,
      switch:
        color.type === 'light'
          ? color.background.interactive.primaryReverse.small
          : color.background.interactive.primary.small,
    },
    off: {
      background: color.type === 'light' ? color.palette.coolgrey[60] : color.palette.coolgrey[50],
      switch: color.palette.white,
    },
  }

  return {
    root: {
      extend: [
        focusWithPseudo({
          radius: pxToRem(40),
          width: size.spacing[56],
          focusSelector: 'has(input:focus-visible)',
        }),
      ],
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative',
    },
    input: {
      extend: [visuallyHidden()],
      position: 'absolute',
      '&:checked + $label:before': {
        background: colors.on.background,
      },
      '&:disabled + $label': {
        opacity: opacity.disabled,
      },
      '&:checked + $label:after': {
        left: pxToRem(27),
      },
      '&:checked:not(:disabled) + $label:after': {
        left: pxToRem(27),
        background: colors.on.switch,
      },
    },
    label: {
      display: 'inline-flex',
      position: 'relative',
      margin: 0,
      padding: 0,
      paddingLeft: `calc(${size.spacing[48]} + ${size.spacing[8]})`,
      fontSize: font.size.small,
      lineHeight: size.spacing[24],
      height: size.spacing[24],
      color: colors.label,
      '&:hover': {
        cursor: 'pointer',
      },
      '&:before': {
        content: "''",
        position: 'absolute',
        display: 'inline-block',
        width: size.spacing[48],
        height: size.spacing[24],
        left: 0,
        top: 0,
        borderRadius: pxToRem(40),
        background: colors.off.background,
      },
      '&:after': {
        content: "''",
        position: 'absolute',
        display: 'inline-block',
        // TODO: create some new spacing tokens?
        top: pxToRem(3),
        left: pxToRem(3),
        width: size.spacing[18],
        height: size.spacing[18],
        borderRadius: '50%',
        transition: 'left 0.25s',
        background: colors.off.switch,
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.20)',
      },
    },
    label_none: {
      paddingLeft: size.spacing[48],
    },
    _small: {
      '&:has(input:focus-visible):after': { width: size.spacing[40] },
      '& > $label': {
        lineHeight: size.spacing[16],
        height: size.spacing[16],
        paddingLeft: `calc(${size.spacing[32]} + ${size.spacing[8]})`,
      },
      '& > $label_none': {
        paddingLeft: size.spacing[32],
      },
      '& > $label:before': {
        width: size.spacing[32],
        height: size.spacing[16],
      },
      '& > $label:after': {
        top: size.spacing[2],
        left: size.spacing[2],
        width: size.spacing[12],
        height: size.spacing[12],
      },
      '& > $input:checked + $label:after': {
        left: size.spacing[18],
      },
    },
  }
}
